
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/linear",
      function () {
        return require("private-next-pages/destinations/linear.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/linear"])
      });
    }
  